"use client";

import { useTranslations } from "next-intl";
import { motion } from "motion/react";

export function Demo() {
  const t = useTranslations("Demo");

  return (
    <div className="bg-white py-24 sm:py-32 dark:bg-slate-900" id="demo">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base leading-7 font-semibold text-purple-600 dark:text-purple-400">
            {t("heading")}
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl dark:text-white">
            {t("title")}
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300">
            {t("description")}
          </p>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="mx-auto max-w-3xl mt-16"
        >
          <div className="relative aspect-video overflow-hidden rounded-xl ring-1 ring-black/10 dark:ring-white/10 shadow-lg">
            <iframe
              className="h-full w-full"
              src={`https://www.youtube.com/embed/YYGVnEX4exI?rel=0`}
              title={t("videoTitle")}
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
